/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Meal } from './Meal';
export type RecommendedMeal = {
    meal: Meal;
    type: RecommendedMeal.type;
    tags: Array<'HIGH_PROTEIN' | 'LOW_CALORIE' | 'BALANCED_MACROS' | 'QUICK_PREP' | 'COMFORT_FOOD' | 'LIGHT_MEAL' | 'HEAVY_MEAL' | 'VEGETARIAN' | 'VEGAN'>;
    score: number;
};
export namespace RecommendedMeal {
    export enum type {
        PERFECT_DIET = 'PERFECT_DIET',
        YOUR_MEAL = 'YOUR_MEAL',
        SAFE_CHOICE = 'SAFE_CHOICE',
        VARIETY_PICK = 'VARIETY_PICK',
    }
}

